import React, { useEffect, createElement } from 'react';
interface SEOHeadProps {
  title: string;
  description: string;
  canonical?: string;
  ogImage?: string;
  ogType?: string;
}
function setMetaTag(name: string, content: string, attribute: string = 'name') {
  let el = document.querySelector(`meta[${attribute}="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attribute, name);
    document.head.appendChild(el);
  }
  el.content = content;
}
function setLinkTag(rel: string, href: string) {
  let el = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement('link');
    el.rel = rel;
    document.head.appendChild(el);
  }
  el.href = href;
}
export function SEOHead({
  title,
  description,
  canonical,
  ogImage = 'https://cdn.magicpatterns.com/uploads/jc63Wcs2z1JuqZfJSF71Nx/logo-white.png',
  ogType = 'website'
}: SEOHeadProps) {
  useEffect(() => {
    document.title = title;
    setMetaTag('description', description);
    setMetaTag('robots', 'index, follow');
    // Open Graph
    setMetaTag('og:title', title, 'property');
    setMetaTag('og:description', description, 'property');
    setMetaTag('og:type', ogType, 'property');
    setMetaTag('og:site_name', 'Smith & Jengs', 'property');
    setMetaTag('og:image', ogImage, 'property');
    if (canonical) {
      setMetaTag('og:url', canonical, 'property');
    } else {
      setMetaTag('og:url', window.location.href, 'property');
    }
    // Twitter Card
    setMetaTag('twitter:card', 'summary_large_image');
    setMetaTag('twitter:title', title);
    setMetaTag('twitter:description', description);
    setMetaTag('twitter:image', ogImage);
    // Canonical
    setLinkTag('canonical', canonical || window.location.href);
  }, [title, description, canonical, ogImage, ogType]);
  return null;
}